import Vue from 'vue';

import Calendar from '../classes/Calendar';

Vue.component('event-form-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            formErrors: {
                //
            },
            submitting: false,
            success: false,
            submitError: false,

            // Calendar
            showDatepicker: false,
            date: null,
            calendar: new Calendar(new Date()),
        };
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

        /**
         *
         */
        onSubmit(event) {
            const formData = new FormData(event.currentTarget);

            if (this.submitting) {
                return;
            }

            // Clear errors.
            this.formErrors = {};

            this.submitting = true;
            axios.post('/organize-event/send-event-data', formData)
            .then((response) => {
                this.submitting = false;
                if (response.data.success) {
                    this.success = true;

                    Vue.nextTick(() => {
                        // const success = this.$el.querySelector('.form-success');
                        // zenscroll.center(success);
                    });
                } else {
                    this.success = false;
                    this.formErrors = response.data.errors;
                }
            })
            .catch((error) => {
                this.success = false;
                this.submitting = false;
                this.submitError = true;
            });
        },

        /**
         * Toggles the datepicker selection.
         */
        toggleDatePicker() {
            if (!this.date) {
                this.showDatepicker = !this.showDatepicker;

                return;
            }

            this.showDatepicker = !this.showDatepicker;
        },

        /**
         * Fetches available times for the given day
         *
         * @param {Object} day
         */
        selectDay(day) {
            this.calendar.selectDay(day);
            this.selectedDay = day;
            this.date = day.date;
            this.showDatepicker = false;
        },

        /**
         *
         */
        setDropdown(event) {
            this[event.target.parentElement.dataset.dropdownName] = event.target.innerHTML;
            this.$root.toggleDropdown(event);
        },
    },
});
